// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__jXF9G","label":"CategoryService_label__3FGWY","location":"CategoryService_location__NHw4g"};